module.exports = __webpack_public_path__ + "img/0Q3A6952_P_L_BlackMatted.0df3f044.jpg";